import { addExternalLinkIcons } from 'Components/00-basics/links';

(function (Drupal) {
  Drupal.behaviors.extlink = {
    attach: function (context, settings) {
      addExternalLinkIcons({
        scope: context,
        excludeHostnames: [
          '*.wright.edu',
          'nuttercenter.com',
          'wright.campus.eab.com',
          'wright.campuslabs.com',
          'wright.force.com',
          'wrightstate.secure.force.com',
          'wrightstate.service-now.com',
          'wrightstatealumni.com',
          'wsuraiders.com',
        ]
      });
    }
  };
} (Drupal));
